'use client'
import { PaginationSkeleton } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

const MarketBorrowersLoading = () => {
  return (
    <div className="gap-xs flex flex-col">
      <Skeleton className="h-[483px] w-[100%] rounded-[20px]" />
      <PaginationSkeleton />
    </div>
  )
}

export default MarketBorrowersLoading
